import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import LogoSygnetClaim from '../../../../assets/images/logo+sygnet+claim.svg';
import Robot from '../../../../assets/images/robot.svg';

interface ErrorTemplateProps {
  children: React.ReactNode;
}

const ErrorTemplate: FC<ErrorTemplateProps> = ({ children }) => {
  return (
    <Box className="error-view">
      <nav className="page-navbar">
        <Box className="container">
          <Box className="fp-logo">
            <img src={LogoSygnetClaim} alt="" />
          </Box>
        </Box>
      </nav>

      <Box className="content">
        <Box className="container">
          <Box className="robot">
            <img src={Robot} alt="" />
          </Box>
          <Box className="info">{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorTemplate;
